export default class BioExamPrescription {
  constructor(
    public id: string,
    public prescriptible: boolean,
    public selected: boolean
  ) {}
}
